export const common = {
  nav: {
    home: 'Accueil',
    products: 'Produits',
    electricFireplaces: 'Cheminées Électriques',
    wallFireplaces: 'Cheminées Sur Pied',
    builtInFireplaces: 'Cheminées Encastrées',
    threeSidedFireplaces: 'Cheminées 3 Faces',
    panoramaFireplaces: 'Cheminées Panorama',
    waterVaporFireplaces: 'Cheminées à Vapeur d\'Eau',
    accessories: 'Accessoires',
    inspiration: 'Inspiration',
    becomeDealer: 'Devenir Revendeur',
    about: 'À Propos de Dutch Fires',
    support: 'Support',
    contact: 'Contact',
    categories: {
      wallFireplaces: 'Cheminées Sur Pied',
      builtIn: 'Cheminées Encastrées',
      threeSided: 'Cheminées 3 Faces',
      panorama: 'Cheminées Panorama',
      waterVapor: 'Cheminées à Vapeur',
      accessories: 'Accessoires'
    }
  },
  hero: {
    badge: 'GROSSISTE B2B',
    title: 'Cheminées Électriques Premium',
    titleSecond: 'Pour Professionnels',
    subtitle: 'Exclusivement disponible via notre réseau officiel de revendeurs européens',
    ctaPrimary: 'Devenir Revendeur',
    ctaSecondary: 'Voir les Produits',
    stats: {
      dealers: 'Revendeurs',
      countries: 'Pays',
      certified: 'Certifié CE'
    }
  },
  usps: {
    europeanBrand: {
      title: 'Marque Européenne',
      description: 'Qualité premium d\'Europe'
    },
    fastDelivery: {
      title: 'Livraison Rapide',
      description: 'Logistique fiable dans toute l\'Europe'
    },
    highMargins: {
      title: 'Marges Élevées',
      description: 'Prix de gros attractifs'
    },
    fullSupport: {
      title: 'Support Complet',
      description: 'Support marketing et technique'
    }
  },
  categories: {
    title: 'Nos Catégories de Produits',
    wallFireplaces: 'Cheminées Murales',
    freestandingFireplaces: 'Cheminées Sur Pied',
    builtIn: 'Cheminées Encastrées',
    threeSided: 'Cheminées 3 Faces',
    panorama: 'Cheminées Panorama',
    waterVapor: 'Cheminées à Vapeur',
    accessories: 'Accessoires',
    models: 'Modèles',
    viewProducts: 'Voir les produits',
    showAll: 'Voir tous les produits',
    clearFilter: 'Effacer le filtre'
  },
  whyDutchFire: {
    label: 'POURQUOI DUTCH FIRES',
    title: 'Votre Partenaire en Solutions de Cheminées Premium',
    subtitle: 'Nous soutenons les revendeurs avec plus que des produits',
    wholesalePrices: {
      title: 'Prix de Gros',
      description: 'Bénéficiez de marges attractives et de prix compétitifs pour votre entreprise.',
      benefits: ['Structure de prix échelonnée', 'Remises sur volume disponibles', 'Conditions transparentes']
    },
    marketingSupport: {
      title: 'Support Marketing',
      description: 'Matériel marketing complet et support pour vos activités de vente.',
      benefits: ['Photos de produits professionnelles', 'Matériel marketing', 'Contenu réseaux sociaux']
    },
    technicalTraining: {
      title: 'Formation Technique',
      description: 'Formation régulière et support technique pour vous et votre équipe.',
      benefits: ['Formation en ligne', 'Démonstrations de produits', 'Support technique 24/7']
    }
  },
  inspiration: {
    label: 'INSPIRATION',
    title: 'Dutch Fires en Action',
    subtitle: 'Découvrez comment nos revendeurs intègrent Dutch Fires dans leurs projets',
    viewProject: 'Voir le projet',
    viewPossibilities: 'Découvrir les possibilités',
    cta: 'Devenir Revendeur – Accéder à Tous les Projets',
    viewAll: 'Voir Tous les Projets',
    projects: {
      luxuryPenthouse: 'Penthouse de Luxe',
      hotelLobby: 'Hall d\'Hôtel',
      modernOffice: 'Bureau Moderne',
      restaurantAmbiance: 'Ambiance Restaurant',
      residentialVilla: 'Villa Résidentielle',
      showroom: 'Showroom'
    }
  },
  inspirationPage: {
    categories: {
      all: 'Tous les Projets',
      residential: 'Résidentiel',
      hospitality: 'Hôtellerie',
      commercial: 'Commercial'
    },
    cta: {
      title: 'Vous voulez Dutch Fires dans vos projets?',
      description: 'Devenez revendeur officiel et accédez à un support projet exclusif, des matériaux marketing et des conseils techniques pour vos installations.',
      button: 'Devenir Revendeur Maintenant'
    }
  },
  dealerBenefits: {
    title: 'Rejoignez 500+ Revendeurs à Succès',
    intro: 'Faites partie de notre réseau croissant de partenaires professionnels à travers l\'Europe et bénéficiez d\'avantages exclusifs.',
    benefit1: {
      title: 'Droits de Territoire Exclusifs',
      description: 'Sécurisez votre territoire et minimisez la concurrence dans votre région.'
    },
    benefit2: {
      title: 'Formation Produit Complète',
      description: 'Formation régulière sur les produits, l\'installation et les techniques de vente.'
    },
    benefit3: {
      title: 'Support Marketing & Ventes',
      description: 'Matériaux professionnels et campagnes pour soutenir votre entreprise.'
    },
    benefit4: {
      title: 'Support Technique',
      description: 'Accès direct à notre équipe d\'experts pour toutes questions techniques.'
    },
    benefit5: {
      title: 'Options de Livraison Flexibles',
      description: 'Dropshipping, stock ou livraison de projet – vous choisissez.'
    },
    stats: {
      dealers: 'Revendeurs Actifs',
      countries: 'Pays',
      satisfaction: 'Satisfaction'
    },
    cta: 'Commencer Votre Inscription'
  },
  dealerProcess: {
    badge: 'PROCESSUS SIMPLE',
    title: 'Devenez Revendeur Officiel en 3 Étapes',
    step1: {
      title: 'S\'inscrire',
      description: 'Remplissez le formulaire en ligne avec vos informations commerciales',
      time: '2 Minutes'
    },
    step2: {
      title: 'Vérification',
      description: 'Nous examinons vos informations et vous contactons personnellement',
      time: '1-2 Jours'
    },
    step3: {
      title: 'Activation',
      description: 'Accédez au portail revendeur et commencez',
      time: 'Immédiatement'
    },
    reassurance: 'Aucune obligation • Inscription gratuite • Contact personnel',
    cta: 'Remplir le Formulaire d\'Inscription'
  },
  testimonials: {
    label: 'CE QUE DISENT LES REVENDEURS',
    title: 'Approuvé par les Professionnels',
    dealerSince: 'Revendeur depuis'
  },
  productShowcase: {
    title: 'Découvrez Notre Collection',
    subtitle: 'Tous les produits disponibles via notre portail revendeur',
    moreInfo: 'Plus d\'informations',
    viewAll: 'Voir Tous les Produits',
    productsFound: 'produits trouvés',
    noProducts: 'Aucun produit trouvé dans cette catégorie'
  },
  resources: {
    downloads: {
      title: 'Ressources Revendeur',
      catalog: 'Catalogue Produits 2025',
      technicalSpecs: 'Spécifications Techniques',
      installationGuide: 'Guide d\'Installation',
      marketingMaterials: 'Matériel Marketing'
    },
    support: {
      title: 'Nous Sommes Là Pour Vous Aider',
      contactText: 'Contactez-nous pour le support revendeur',
      email: 'Support Email',
      emailResponse: 'Réponse sous 24h'
    }
  },
  footer: {
    tagline: 'Solutions de Cheminées B2B Premium',
    newsletter: {
      placeholder: 'Votre adresse email professionnelle',
      disclaimer: 'Clients professionnels uniquement'
    },
    products: 'Produits',
    information: 'Information',
    contact: 'Contact',
    copyright: '© 2025 Dutch Fires',
    businessOnly: 'Clients professionnels uniquement',
    legal: {
      imprint: 'Mentions Légales',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      cookies: 'Cookies'
    }
  },
  common: {
    learnMore: 'En savoir plus',
    contactUs: 'Contactez-nous'
  },
  cookies: {
    title: 'Paramètres des cookies',
    description: 'Nous utilisons des cookies pour améliorer votre expérience et analyser notre site web. Vous pouvez ajuster vos paramètres à tout moment.',
    settings: 'Paramètres',
    necessaryOnly: 'Nécessaires uniquement',
    acceptAll: 'Tout accepter',
    settingsTitle: 'Gérer les paramètres des cookies',
    savePreferences: 'Enregistrer les préférences',
    alwaysOn: 'Toujours actif',
    necessary: {
      title: 'Cookies nécessaires',
      description: 'Ces cookies sont requis pour les fonctionnalités de base du site et ne peuvent pas être désactivés.'
    },
    analytics: {
      title: 'Cookies analytiques',
      description: 'Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site.'
    },
    marketing: {
      title: 'Cookies marketing',
      description: 'Ces cookies sont utilisés pour rendre la publicité plus pertinente pour vous.'
    }
  },
  productCTA: {
    b2bOnly: 'B2B uniquement',
    dealerOnly: 'Réservé aux revendeurs',
    title: 'Intéressé par ce produit?',
    titleWithProduct: 'Intéressé par {{product}}?',
    description: 'Devenez revendeur officiel Dutch Fires et accédez aux prix de gros, conditions exclusives et support complet.',
    interestedInProduct: 'Intéressé par {{product}}? Devenez revendeur pour les prix et commandes.',
    interestedGeneral: 'Intéressé par nos produits? Devenez revendeur pour les prix et commandes.',
    inlineTitle: 'Prix disponibles uniquement pour les revendeurs enregistrés',
    benefit1: 'Accès aux prix de gros',
    benefit2: 'Conditions revendeur exclusives',
    benefit3: 'Accompagnement personnalisé',
    becomeDealer: 'Devenir revendeur',
    ctaButton: 'Devenir Revendeur Maintenant',
    disclaimer: 'Uniquement pour les entreprises avec enregistrement valide',
    viewDetails: 'Voir les détails'
  }
};